import script from "./ListarDescontos.vue?vue&type=script&setup=true&lang=js"
export * from "./ListarDescontos.vue?vue&type=script&setup=true&lang=js"

import "./ListarDescontos.vue?vue&type=style&index=0&id=146e6750&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-146e6750"]])

export default __exports__